import type { IForumTopicReactions } from '~~/types/local_types';

const getForumItems = () => {

  const getForumApiUrl = () => {
    const config = useRuntimeConfig();
    const { forumUrl } = config.public;
    return forumUrl;
  };

  const getTopList = async (amount?: number) => {
    const { data: forumTopList } = useNuxtData('forumTopList');

    if (!forumTopList.value) {
      const { data: newTopList } = await useFetch(
        `${getForumApiUrl()}json.php?type=toplist${amount ? `&size=${amount}` : ''}`,
        {
          key: 'forumTopList',
        },
      );
      return newTopList.value;
    }

    return forumTopList.value;
  };

  const getList = async (topics: Array<number>, id: number) => {
    const { data: forumList } = useNuxtData(`forumList-${id}`);

    if (!forumList.value) {
      const { data: newList } = await useFetch(
        `${getForumApiUrl()}json.php?type=topics&topic_ids=${topics.join(', ')}`,
        {
          key: `forumList-${id}`,
        },
      );
      return newList.value;
    }

    return forumList.value;
  };

  const getLatestTopicReactions = async (id: number, size: number = 4) => {

    const key = `forumTopicReactions_${id}__${size}`;
    const { data: forumTopicReactions } = useNuxtData(key);

    if (!forumTopicReactions.value) {

      const { data: newTopicReactions } = await useFetch(
        `${getForumApiUrl()}json.php?type=posts&topic_id=${id}&size=${size}`,
        {
          key: key,
          onResponse({ response }) {
            const contentType = response.headers.get('content-type') ?? '';
            if (!contentType.includes('application/json')) {
              throw new Error(`Expected JSON, got: ${contentType}`);
            }
          },
          transform: (rawResponse): IForumTopicReactions => {
            if (!rawResponse || !Array.isArray(rawResponse) || rawResponse.length === 0) {
              return { replies: [], topic_status: undefined, topic_posts_approved: 0 };
            }

            const { topic_status } = rawResponse[0];
            let topic_posts_approved = rawResponse[0].topic_posts_approved;

            // the first post is always the topic starter's initial post, not a reaction, so remove it
            if (rawResponse[0].special !== 0) {
              rawResponse.shift();
              topic_posts_approved -= 1;
              for (let i = 0; i < rawResponse.length; i++) {
                rawResponse[i].topic_posts_approved -= 1;
              }
            }

            return { replies: rawResponse, topic_status, topic_posts_approved };
          },
        },
      );

      return newTopicReactions.value || { replies: [], topic_status: undefined, topic_posts_approved: 0 };
    }

    return forumTopicReactions.value || { replies: [], topic_status: undefined, topic_posts_approved: 0 };
  };

  return { getList, getTopList, getLatestTopicReactions };
};

export default getForumItems();
